export class NoOrderSelector {
    constructor() {
        this.type = "NoOrder";
    }
    test(purchaseOrderPayload) {
        return false;
    }
}
